import { EPAYMENT_INITIALISE_TYPES } from "@constants";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { priceToCents } from "src/itsf/utils/priceUtils";
import { EJccFormTypes } from "../interface/IPayment";
import CardPayment from "../ManageCards/CardPayment";
import "./css/PaymentBalanceIframe.scss";
import { useMyBalancePayment } from "./hook/useMyBalancePayment";

interface IParams {
    amountToPay: number;
    openedJccForm?: EJccFormTypes;
    setOpenedJccForm(openedJccForm?: EJccFormTypes): void;
}

export const PaymentBalanceCardPay = (props: IParams) => {
    const { amountToPay, openedJccForm, setOpenedJccForm } = props;
    const { formMethods, handleRangePriceValue } = useMyBalancePayment(amountToPay);
    const { register, errors, setValue, getValues } = formMethods;
    const { t } = useTranslation(["payment", "common", "validation"]);

    const onChange = (event: ChangeEvent<HTMLInputElement>) => {
        const { value } = event.target;
        let newValue = "";
        if (value) {
            const index = value.includes(".") ? value.indexOf(".") : value.length;
            newValue = value.slice(0, index + 3);
        }
        setValue("balance", newValue);
    };

    const isPayBalanceOpened: boolean = openedJccForm === EJccFormTypes.PAY_BALANCE;

    const handlePayNowClick = () => {
        setOpenedJccForm(EJccFormTypes.PAY_BALANCE);
    };

    return (
        <>
            <form>
                <Grid alignItems="center" container direction="column" justify="center" spacing={2}>
                    <Grid item md={2} style={{ flex: "1 1 auto" }} xs={7}>
                        <TextField
                            aria-label="amount"
                            className="balance_input"
                            error={Boolean(errors.balance)}
                            fullWidth
                            helperText={errors.balance?.message}
                            id="balanceField"
                            inputProps={{ "data-testid": "input-amount" }}
                            inputRef={register({
                                required: t("validation:required"),
                                validate: handleRangePriceValue,
                            })}
                            margin="dense"
                            name="balance"
                            type="string"
                            disabled={isPayBalanceOpened}
                            onChange={onChange}
                        />
                    </Grid>
                    <Grid item md={3} sm={4} style={{ flex: "1 1 auto" }} xs={6}>
                        <Button
                            color="secondary"
                            disabled={Boolean(errors.balance) || isPayBalanceOpened}
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={handlePayNowClick}
                        >
                            {t("payment:payNow")}
                        </Button>
                    </Grid>
                </Grid>
            </form>
            {isPayBalanceOpened && (
                <CardPayment
                    serviceId={0}
                    isOnceOffPayment={true}
                    loadDefaultCard={true}
                    paymentType={EPAYMENT_INITIALISE_TYPES.MY_BALANCE_PAYMENT}
                    amount={priceToCents(getValues("balance"))}
                />
            )}
        </>
    );
};
